import { Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';

// local imports
import { RegionService } from 'app/services';
import { useInputChangeHandler } from 'app/hooks';
import { LeafletMapForm } from 'app/components/molecules';
import { CustomAutoComplete, FormInput } from 'app/components/atoms';

const RegionForm = ({ loading, isEdit }) => {
  const { values, setFieldValue } = useInputChangeHandler();
  const [cityOptions, setCityOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);

  const _location = values?.location && JSON.parse(values?.location);

  // variables
  const cityVal = values?.city_id?.value;
  const districtVal = values?.district_id?.value;
  const regionVal = values?.region_id?.value;
  const isDisabled = {
    district: !!cityVal,
    region: !!districtVal
  };

  // *** handle async autocomplete
  const handleAutoComplete = (name, e) => {
    switch (name) {
      case 'city_id':
        setFieldValue('district_id', null);
        setFieldValue('region_id', null);
        break;
      case 'district_id':
        setFieldValue('region_id', null);
        break;
      default:
        break;
    }
    setFieldValue(name, e);
  };

  // fetch cities
  const defaultCity = async () => {
    try {
      const data = await RegionService.getCityListWithoutPagination();
      const out = data?.data?.data.map(i => ({ label: i.name, value: i.id }));
      setCityOptions(out);
      return out;
    } catch (err) {
      console.log('error :>> ', err);
    }
  };

  useEffect(() => defaultCity(), []);

  /* Conditional customSelect value changes  */
  useEffect(() => {
    // get district options
    const handleDistrictOptions = async () => {
      if (cityVal) {
        try {
          const data = await RegionService.getDistrictListWithoutPagination(
            { filter: '' },
            cityVal
          );
          const out = data?.data?.data?.map(i => ({ label: i.name, value: i.id }));
          setDistrictOptions(out);
          return out;
        } catch (err) {
          console.log('err :>> ', err);
        }
      }
    };

    // get region options
    const handleRegionOptions = async () => {
      if (districtVal) {
        try {
          const data = await RegionService.getRegionListWithoutPagination(
            { filter: '' },
            cityVal,
            districtVal
          );

          const out = data?.data?.data.map(i => ({ label: i.name, value: i.id }));
          setRegionOptions(out);
          return out;
        } catch (err) {
          console.log('err:=>', err);
        }
      }
    };

    /* Set options conditionally */
    if (cityVal) {
      setDistrictOptions([]);
      handleDistrictOptions();
      if (districtVal) {
        // setRegionOptions([]);
        handleRegionOptions();
      }
    } else {
      setFieldValue('district_id', null);
      setFieldValue('region_id', null);
      setDistrictOptions([]);
      setRegionOptions([]);
    }
  }, [cityVal, districtVal, regionVal, setFieldValue]);

  return (
    <Grid container spacing={2}>
      {isEdit ? (
        <>
          <Grid item xs={12} sm={6} md={4} xl={3} className="space-y-12">
            <Grid item>
              <CustomAutoComplete
                id="id_city"
                name="city_id"
                label="İl"
                placeholder="İl Seçiniz..."
                options={cityOptions || []}
                value={values?.city_id || ''}
                onChange={handleAutoComplete}
                disabled={loading}
              />
            </Grid>

            <Grid item>
              <CustomAutoComplete
                id="id_district"
                label="İlçe"
                name="district_id"
                placeholder="İlçe Seçiniz..."
                options={districtOptions || []}
                disabled={!isDisabled.district || loading}
                value={values?.district_id || ''}
                onChange={handleAutoComplete}
              />
            </Grid>

            <Grid item>
              <CustomAutoComplete
                id="id_region"
                label="Semt/Mahalle"
                name="region_id"
                placeholder="Semt/Mahalle Seçiniz..."
                options={regionOptions || []}
                disabled={!isDisabled.region || loading}
                value={values?.region_id || ''}
                onChange={handleAutoComplete}
              />
            </Grid>

            <Grid item>
              <FormInput
                multiline
                rows={9}
                id="pharmacy_address"
                label="Adres"
                name="address"
                placeholder="Adres"
                value={values?.address || ''}
                disabled={loading}
                maxLength={255}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={8} xl={9} className="">
            <Grid item>
              <div className="mb-8">
                <span className="font-semibold text-gray-700 mr-4">Lokasyon</span>
              </div>
              <LeafletMapForm location={_location} />
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12} sm={6} md={4} xl={3}>
            <CustomAutoComplete
              id="id_city"
              name="city_id"
              label="İl"
              placeholder="İl Seçiniz..."
              options={cityOptions || []}
              value={values?.city_id || ''}
              onChange={handleAutoComplete}
              disabled={loading}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} xl={3}>
            <CustomAutoComplete
              id="id_district"
              label="İlçe"
              name="district_id"
              placeholder="İlçe Seçiniz..."
              options={districtOptions || []}
              disabled={!isDisabled.district || loading}
              value={values?.district_id || ''}
              onChange={handleAutoComplete}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} xl={3}>
            <CustomAutoComplete
              id="id_region"
              label="Semt/Mahalle"
              name="region_id"
              placeholder="Semt/Mahalle Seçiniz..."
              options={regionOptions || []}
              disabled={!isDisabled.region || loading}
              value={values?.region_id || ''}
              onChange={handleAutoComplete}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} xl={3}>
            <FormInput
              multiline
              rows={5}
              id="pharmacy_address"
              label="Adres"
              name="address"
              placeholder="Adres"
              value={values?.address || ''}
              disabled={loading}
              maxLength={255}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default RegionForm;
